/**
 * Typed wrappers for the cross-tenant super-admin Leads endpoints.
 *
 * Leads are read-only in the super-admin plane (list + detail). The list is
 * cross-tenant by default; `companyId` narrows it to one tenant, and the other
 * filters mirror the backend LeadsListQuerySchema. `deleted=true` surfaces
 * rep-deleted leads. Detail returns the raw enriched lead record.
 */
import type { LeadsPage } from '@viq-admin/types';
import { superadminFetch } from './dataProvider';

export interface LeadsFilter {
  conferenceId?: string;
  companyId?: string;
  repOid?: string;
  from?: string;
  to?: string;
  captureType?: string;
  cursor?: string;
  limit?: number;
  deleted?: boolean;
}

/** GET /v1/superadmin/leads?<filters> → one cursor-paginated page. */
export async function listLeads(f: LeadsFilter): Promise<LeadsPage> {
  const params = new URLSearchParams();
  if (f.conferenceId) params.set('conferenceId', f.conferenceId);
  if (f.companyId) params.set('companyId', f.companyId);
  if (f.repOid) params.set('repOid', f.repOid);
  if (f.from) params.set('from', f.from);
  if (f.to) params.set('to', f.to);
  if (f.captureType) params.set('captureType', f.captureType);
  if (f.cursor) params.set('cursor', f.cursor);
  if (f.limit !== undefined) params.set('limit', String(f.limit));
  if (f.deleted === true) params.set('deleted', 'true');
  const qs = params.toString() ? `?${params.toString()}` : '';
  return superadminFetch<LeadsPage>(`/v1/superadmin/leads${qs}`);
}
